<script setup lang="ts">
import { RouterView, useRoute } from 'vue-router'
import { computed } from 'vue'
import AppNav from '@/components/layout/AppNav.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
import ScrollProgress from '@/components/layout/ScrollProgress.vue'
import FloatingCta from '@/components/layout/FloatingCta.vue'

const route = useRoute()
const isHome = computed(() => route.name === 'home')
const isLegal = computed(() => route.name === 'imprint' || route.name === 'privacy')
</script>

<template>
	<ScrollProgress v-if="!isLegal" />
	<FloatingCta v-if="isHome" />
	<AppNav v-if="!isLegal" />
	<RouterView />
	<AppFooter />
</template>
